module.exports = __webpack_public_path__ + "img/mozgo-logo-vote.7c43ffc6.svg";